import Adal from '../adal/adal-request';
import { CIP_TYPE, encodeData, REST_URL } from '../constants';
import * as types from './actionTypes';

export function fetchCipFilesAction(cipIdeaId) {
  const filter = {ownerId: cipIdeaId, ownerType: CIP_TYPE};
  return ({
    type: types.FETCH_CIP_FILES,
    payload: Adal.adalRequest({url: `${REST_URL}fileItems?${encodeData(filter)}`})
  });
}



// WEBPACK FOOTER //
// ./actions/fileActions.js